import { INotification } from './INotification'

export const GET_NOTIFICATIONS_LOADING = 'GET_NOTIFICATIONS_LOADING'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE'

export const READ_NOTIFICATION = 'READ_NOTIFICATION'

interface IGetNotificationSuccess {
  type: typeof GET_NOTIFICATIONS_SUCCESS
  payload: {
    list: INotification[]
  }
}

interface IGetNotificationFailure {
  type: typeof GET_NOTIFICATIONS_FAILURE
  payload: {
    error: string
  }
}

interface IGetNotification {
  type: typeof GET_NOTIFICATIONS_LOADING
}

interface IReadNotification {
  type: typeof READ_NOTIFICATION
  payload: {
    id: string
  }
}

export type TActionTypes =
  | IGetNotificationSuccess
  | IGetNotificationFailure
  | IGetNotification
  | IReadNotification
